export default __webpack_public_path__ + "static/media/quote-img-2.a6ad5d62.svg";